import axios from './axiosClient'
import * as _ from '../services/config'

export async function itemClick(href, active, isDefaultView, self) {

    if (!active) return;

    //self.$emit("showLoading", true);
    _.ShowLoadingPane(self, true);
    var authenticatePromise = await axios.get("/api/Auth/IsAuthenticated");
    var response = authenticatePromise.data;
    if (response === "") {
        self.showLoadingPane();
        location.reload();
    }
    var urlWithToken = await GetLoginTokenForDataminerURL(href, isDefaultView)
    OpenURLWithNewTab(urlWithToken, self);
}
var GetLoginTokenForDataminerURL = async function (href, isDefaultView) {

    var url = "/api/Hubs/GetURL?link=" + href + "&isDefaultView=" + isDefaultView;
    var urlPromise = await axios.get(url);
    return urlPromise.data;
};
var OpenURLWithNewTab = function (url, self) {

    //self.$emit("showLoading", false);
    _.ShowLoadingPane(self, false);
    self.login = true;
    window.open(url, "_blank");
};


